import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'

import Link from './Link'

import { formatDate } from '../../utils/date'

const PressPostSummary = ({
  date,
  sourceLink,
  sourceTitle,
  readMoreLink,
  title,
  image
}) => (
  <div className='presspost-summary flex items-center left-align'>
    <div className='presspost-summary__thumbnail flex-none mr2'>
      <img width='80' src={image} alt='' />
    </div>
    <div className='presspost-summary__content'>
      <Link
        className='h4 presspost-summary__title block'
        target='_blank'
        href={sourceLink}
        dangerouslySetInnerHTML={{ __html: title }}
      />
      <span className='presspost-summary__date'>
        {sourceTitle && <span>{sourceTitle}, </span>}
        <span>{formatDate(date)} </span>
      </span>
      <Link
        target='_blank'
        className='presspost-summary__subtitle'
        href={readMoreLink || sourceLink}
      >
        Read more
      </Link>
    </div>
  </div>
)

PressPostSummary.propTypes = {
  date: PropTypes.string.isRequired,
  sourceLink: PropTypes.string.isRequired,
  sourceTitle: PropTypes.string,
  readMoreLink: PropTypes.string,
  title: PropTypes.string.isRequired
}

export default connect()(PressPostSummary)



// WEBPACK FOOTER //
// ./frontend/scripts/react/components/PressPostSummary.js